import { createAsyncThunk } from '@reduxjs/toolkit';
import { isNotDefined } from '@sgme/fp';

import { logger } from '@/components/SgwtBootstrap/logger.ts';
import { selectBulkTrade } from '@/store/bulkTrade/selectors.ts';
import { bulkTradeSlice } from '@/store/bulkTrade/slice.ts';
import { espApi } from '@/store/esp/api';
import { espSlice } from '@/store/esp/slice.ts';
import type { AppState } from '@/store/store.ts';
import { selectTabClientId } from '@/store/tabs/selectors.ts';
import { getTodayDateOnly } from '@/utils/date.ts';

export const subscribeBulkTradeToEsp = createAsyncThunk(
  'bulkTrade/changeCurrencyPair',
  async (payload: { tabId: string }, thunkAPI) => {
    const { tabId } = payload;

    const state = thunkAPI.getState() as AppState;
    const bulkTrade = selectBulkTrade(state, tabId);

    // is currency pair undefined, do nothing
    if (isNotDefined(bulkTrade?.currencyPair)) {
      return;
    }

    const clientId = selectTabClientId(state, tabId);

    // no client selected for this tab, do nothing
    if (isNotDefined(clientId)) {
      return;
    }

    const spotDate = getTodayDateOnly();

    const tieringResponse = await thunkAPI
      .dispatch(
        espApi.endpoints.getEspTiering.initiate({
          clientId,
          currencyPair: bulkTrade.currencyPair,
          spotDate,
        }),
      )
      .unwrap();

    const tiering = 'tiering' in tieringResponse ? tieringResponse.tiering : undefined;

    if (isNotDefined(tiering)) {
      // no tiering available for this client/currency pair, nothing to subscribe to
      logger.logWarning(`[BULKTRADE] no ESP tiering found for ${bulkTrade.currencyPair} / client ${clientId}`);
      return;
    }

    thunkAPI.dispatch(bulkTradeSlice.actions.tieringChanged({ tabId, tiering }));

    thunkAPI.dispatch(
      espSlice.actions.espStreamSubscribed({
        bdrId: clientId,
        currencyPair: bulkTrade.currencyPair,
        tiering,
        tileId: `${tabId}/BULK_TRADE`,
      }),
    );
  },
);
